import React from 'react';

import type { SpaceProps } from '../../theme/system-types';
import { CaptionRegularCR1 } from '../Typography';

interface FieldInfoProps extends SpaceProps {
  info?: string;
}

export const FieldInfo = ({ info, ...styles }: FieldInfoProps) =>
  info ? (
    <CaptionRegularCR1 as="small" ml="sp_16" {...styles}>
      {info}
    </CaptionRegularCR1>
  ) : null;
